import { render } from "./FloatingHeader.vue?vue&type=template&id=779f92eb&scoped=true"
import script from "./FloatingHeader.vue?vue&type=script&lang=js"
export * from "./FloatingHeader.vue?vue&type=script&lang=js"

import "./FloatingHeader.vue?vue&type=style&index=0&id=779f92eb&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779f92eb"]])

export default __exports__